import React,{useState} from "react";
import { Link } from "react-router-dom";


import image1 from '../assets/images/logos/web_dev.png'
import image2 from '../assets/images/logos/mob_dev.png'
import image3 from '../assets/images/logos/ui_ux.png'



export default function Services(){
    
    const images = [image1, image2, image3]

    

    const data = [
        {
            id:0,
            image:image1,
            title:"Web Development",
            description:"Laravel | PHP | JS | API",
        },
        {
            id:1,
            image:image2,
            title:"App Development",
            description:"React Native | Java | ASO",
        },
        {
            id:2,
            image:image3,
            title:"UI/UX Design",
            description:"Figma | XD",
        },
        
    ]
 
    return(
        <>
         <div className="container relative md:mt-16 mt-8">
                <div className="grid grid-cols-1 pb-6 text-center">
                    <h3 className="mb-6 md:text-2xl text-xl font-medium">What I Do?</h3>

                    <p className="text-slate-400 dark:text-white/60 max-w-xl mx-auto">I design and code beautifully simple things, and I love what I do.
                    </p>
                </div>

                <div className="container-fluid relative">
                    <div id="grid" className="grid md:grid-cols-3 grid-cols-1 mt-4 gap-[30px] lg:px-6 px-4">
                    {data.map((item,index)=>{
                        return(                      
                            <div className="w-100 bg-white dark:bg-slate-900 shadow dark:shadow-gray-700 text-center rounded-xl mx-auto py-6">
                                <img src={item.image} className="w-20 mb-6 mx-auto"/>
                                <span className="text-xl">{item.title}</span>
                                <h1 className="mt-2 dark:text-white/60">{item.description}</h1>    
                            </div>
                        )
                    })}
                       
                    </div>
                </div> 
            </div>
        </>
    )
}